import i18n from "../i18n";

// Labels are translated for the dropdown; the codes are what eBay receives, so never translated.
const tr = (key: string) => i18n.t(key, { ns: "messages" });

/**
 * eBay's own reason codes, so every reason dropdown matches what eBay accepts exactly.
 *
 * Refunds: Sell Fulfillment API `issueRefund`, ReasonForRefundEnum (all seven values, checked
 * 27 Oct 2026). eBay's descriptions say which are for a full refund, a partial one, or either.
 * Cancellations: Post-Order `cancellation`, the seller-side CancelReasonEnum - the same four
 * Wilma's eBay cancel accepts (`PartOfferService.SellerCancelReasons`) and the Stock page offers.
 */
export interface IEbayReason {
  code: string;
  label: string;
}

const REFUND_REASONS: (IEbayReason & { full: boolean; partial: boolean })[] = [
  { code: "BUYER_CANCEL", label: "Buyer cancelled the order", full: true, partial: false },
  { code: "SELLER_CANCEL", label: "Seller cancelled the order (e.g. out of stock or damaged)", full: true, partial: false },
  { code: "ITEM_NOT_RECEIVED", label: "Item not received", full: true, partial: false },
  { code: "BUYER_RETURN", label: "Buyer returned the item (not 'not as described')", full: true, partial: false },
  { code: "ITEM_NOT_AS_DESCRIBED", label: "Item not as described", full: true, partial: true },
  { code: "OTHER_ADJUSTMENT", label: "Other adjustment", full: true, partial: true },
  { code: "SHIPPING_DISCOUNT", label: "Shipping discount", full: false, partial: true },
];

export function ebayRefundReasons(kind: "full" | "partial"): IEbayReason[] {
  return REFUND_REASONS.filter((r) => r[kind]).map(({ code, label }) => ({ code, label: tr(label) }));
}

/** Seller-side cancel reasons. eBay rejects "Order Unpaid" on an order it has taken payment for. */
export function ebayCancelReasons(isPaid: boolean): IEbayReason[] {
  return [
    { code: "ADDRESS_ISSUES", label: tr("Address Issues") },
    { code: "BUYER_ASKED_CANCEL", label: tr("Buyer Requested Cancellation") },
    ...(isPaid ? [] : [{ code: "ORDER_UNPAID", label: tr("Order Unpaid") }]),
    { code: "OUT_OF_STOCK_OR_CANNOT_FULFILL", label: tr("Out of Stock or Cannot Fulfill") },
  ];
}
